import CardCharts from "../../components/common/CardCharts/CardCharts";
import CardStats from "../../components/common/CardStats/CardStats";
import Table from "../../components/common/Table/Table";
import ProgressCircle from "../../components/common/ProgressCircle/ProgressCircle";
import SimpleLineChartGraph from "../../components/common/Charts/SimpleLineChartGraph";
import BarChartGraph from "../../components/common/Charts/BarChartGraph";
import PageLayout from "../../Layouts/PageLayout/PageLayout";
import {
  barChartData,
  lineChartData,
  dashboardStatsData,
  topPaisesData,
  columnasPaises,
  indicadoresData,
  centrosMapData,
} from "./data/data";
import "./Dashboard.scss";
import MapComponent from "../../components/common/MapComponent/MapComponent";
import { useEffect, useState } from "react";
import { getApiInstance } from "../../utils/api";
import { useZone } from "../../context/ZoneContext";
import { formatDate } from "../../utils/utils";
import { FiPlay, FiUsers } from "react-icons/fi";
import { IoStopOutline } from "react-icons/io5";
import { LuWeight } from "react-icons/lu";
import { MdEuroSymbol } from "react-icons/md";
import ProgressBar from "../../components/common/ProgressBar/ProgressBar";
import Badge from "../../components/common/Badge/Badge";
import Button from "../../components/common/Button/Button";
import { CiClock1 } from "react-icons/ci";
import { CgDanger } from "react-icons/cg";
import { CiCircleCheck } from "react-icons/ci";
import { CiCircleInfo } from "react-icons/ci";
import { CiWarning } from "react-icons/ci";

const cumplimientoStates = [
  { label: "Sin datos", type: "info", Icon: CiClock1 },
  { label: "Pendiente", type: "info", Icon: CiClock1 },
  { label: "Validado con incidencias", type: "warning", Icon: CgDanger },
  { label: "Validada", type: "success", Icon: CiCircleCheck },
];

export default function Dashboard() {
  const [obras, setObras] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { selectedZone } = useZone();
  const [mapCenter, setMapCenter] = useState([40.0, -4.0]);
  const [zoom, setZoom] = useState(5);

  const fetchObras = async () => {
    setLoading(true);
    try {
      const api = getApiInstance();
      const response = await api.get(
        `/api/Obra/GetObrasFromZona/${selectedZone.value}/1/es`
      );

      setObras(response.data);
      console.log(
        "obras state justo después de setObras (response.data):",
        response.data
      );
      console.log(
        "Primer item de response.data:",
        response.data && response.data[0]
      );
      setError(null);
    } catch (err) {
      setError(
        "No se han podido cargar las obras. Vuelve a intentarlo más tarde."
      );
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchObras();

    if (selectedZone.value == 2) {
      setMapCenter([24.056145870396488, -102.51185975545415]);
      setZoom(5);
    } else if (selectedZone.value == 3) {
      setMapCenter([32.679109313985286, -28.420501580530633]);
      setZoom(1);
    } else {
      setMapCenter([40.0, -4.0]);
      setZoom(5);
    }
  }, [selectedZone]);

  // Función para obtener el porcentaje de valorización único para cada centro
  const getValorizacionStatus = (centro) => {
    // Si viene el porcentaje real de la API, usarlo
    if (
      centro.porcentajeValorizacion !== undefined &&
      centro.porcentajeValorizacion !== null
    ) {
      return Math.max(0, Math.min(100, centro.porcentajeValorizacion));
    }

    // Generar porcentaje único basado en el ID del centro
    const id = centro.codObra || centro.id || centro.codEspacio || "0";
    let hash = 0;
    const str = id.toString();

    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Convert to 32bit integer
    }

    // Convertir hash a porcentaje entre 0-100
    const percentage = Math.abs(hash) % 101;
    return percentage;
  };

  // Función para obtener el estado de cumplimiento
  const getCumplimientoStatus = (centro) => {
    switch (centro.codEstado) {
      case "COMPLETADO":
      case "VALIDADO":
        return { status: "CORRECTO", variant: "success", Icon: CiCircleCheck };
      case "INCIDENCIA":
      case "RETRASADO":
        return { status: "INCORRECTO", variant: "danger", Icon: CgDanger };
      case "PENDIENTE":
      case "EN_PROGRESO":
        return { status: "PENDIENTE", variant: "warning", Icon: CiWarning };
      default:
        return { status: "SIN DATOS", variant: "outlined", Icon: CiCircleInfo };
    }
  };

  const modalMap = (centro) => {
    return (
      <div className="centro-map-details">
        <div className="centro-header">
          <h3 className="centro-title">
            {centro.nombre || centro.codEspacio || ""}, {centro.direccion || ""}
          </h3>
        </div>

        <div className="centro-info-section">
          <div className="info-row">
            <FiPlay className="info-icon" />
            <span className="info-label">Fecha inicio</span>
            <span className="info-value">
              {formatDate(centro.fechaInicio) || ""}
            </span>
          </div>
          <div className="info-row">
            <IoStopOutline className="info-icon" />
            <span className="info-label">Fecha fin</span>
            <span className="info-value">
              {formatDate(centro.fechaFin) || ""}
            </span>
          </div>

          <div className="info-row info-row--highlight">
            <FiUsers className="info-icon" />
            <span className="info-label">Intermediario</span>
            <span className="info-value intermediario-link">
              {centro.intermediario || ""}
            </span>
          </div>

          <div className="info-row">
            <LuWeight className="info-icon" />
            <span className="info-label">Cantidades generadas</span>
            <span className="info-value">{centro.peso || ""}</span>
          </div>

          <div className="info-row">
            <MdEuroSymbol className="info-icon" />
            <span className="info-label">Coste</span>
            <span className="info-value">{centro.costeTotal || ""}</span>
          </div>
        </div>

        <div className="centro-valorizacion-section">
          <h4 className="section-title">Valorización</h4>
          <div className="valorizacion-percentage">
            {(centro.peso
              ? (centro.valorizacion / centro.peso) * 100
              : 0
            ).toFixed(2)}
            %
          </div>
          <ProgressBar
            percentage={
              (centro.peso
                ? (centro.valorizacion / centro.peso) * 100
                : 0
              ).toFixed(2) || 0
            }
            height={8}
            width="100%"
          />
        </div>

        <div className="centro-cumplimiento-section">
          <div className="cumplimiento-header">
            <h4 className="section-title">Cumplimiento Legal</h4>
            <Badge
              variant={getCumplimientoStatus(centro).variant}
              Icon={getCumplimientoStatus(centro).Icon}
            >
              {getCumplimientoStatus(centro).status}
            </Badge>
            {centro.cumplimientos.map((cumplimiento, index) => (
              <div key={index} className="cumplimiento-item">
                <span className="cumplimiento-name">
                  {cumplimiento.nombre || ""}
                </span>
                <Badge
                  variant={cumplimientoStates[centro.codEstado].variant}
                  Icon={cumplimientoStates[centro.codEstado].Icon}
                >
                  {cumplimientoStates[centro.codEstado].status}
                </Badge>
              </div>
            ))}
          </div>
        </div>

        <div className="modal-actions">
          <Button
            variant="filled"
            onClick={() => {
              window.location.href = `/centros-productores/${centro.codObra}`;
            }}
          >
            Ver Ficha Completa
          </Button>
        </div>
      </div>
    );
  };

  console.log("Render Dashboard -> obras.length:", obras?.length);

  return (
    <PageLayout
      title="Resumen de tu actividad"
      subtitle="Aquí visualizarás un resumen de los datos más importantes de tu organización"
    >
      <div className="dashboard__hero">
        <CardStats
          title={dashboardStatsData.totalCentros.title}
          subtitle={dashboardStatsData.totalCentros.subtitle}
          data={{ metrics: dashboardStatsData.totalCentros.metrics }}
        />

        <CardStats
          title={dashboardStatsData.cantidadGenerada.title}
          subtitle={dashboardStatsData.cantidadGenerada.subtitle}
          data={{ metrics: dashboardStatsData.cantidadGenerada.metrics }}
        />
        <CardStats
          title={dashboardStatsData.eficienciaGlobal.title}
          subtitle={dashboardStatsData.eficienciaGlobal.subtitle}
          data={{ metrics: dashboardStatsData.eficienciaGlobal.metrics }}
        />
      </div>

      <div className="dashboard__indicators">
        <CardCharts
          title="Indicadores clave"
          subtitle="Métricas de rendimiento"
        >
          <div className="dashboard__circles-grid">
            {indicadoresData.map((indicador, index) => (
              <ProgressCircle
                key={index}
                percentage={indicador.percentage}
                label={indicador.label}
                value={indicador.value}
                className="progress-circle--large"
              />
            ))}
          </div>
        </CardCharts>
      </div>

      <div className="dashboard__charts">
        <CardCharts
          title="Evolución temporal"
          subtitle="Tendencia de generación"
          data={lineChartData}
        >
          <SimpleLineChartGraph data={lineChartData} />
        </CardCharts>

        <CardCharts
          title="Distribución por tipo"
          subtitle="Categorías de residuos"
          data={barChartData}
        >
          <BarChartGraph data={barChartData} />
        </CardCharts>
      </div>

      <div className="dashboard__bottom">
        {/* <Table
          columns={columnasPaises}
          dataTable={topPaisesData}
          noResultsMessage="No hay datos disponibles"
          topContent={
            <div className="dashboard__table-header">
              <div className="dashboard__table-text">
                <h3 className="dashboard__table-title">
                  Principales áreas por valorización
                </h3>
                <p className="dashboard__table-subtitle">
                  Dónde el porcentaje de reciclado es mayor
                </p>
              </div>
            </div>
          }
        /> */}

        <div style={{ width: "100%" }}>
          <MapComponent
            data={obras}
            center={mapCenter}
            zoom={zoom}
            height="600px"
            width="100%"
            modalContent={modalMap}
          />
        </div>
      </div>
    </PageLayout>
  );
}
